<template>
  <footer class="footer">
    <!-- <div class="footer-wrap">
      <div class="txt">關注我們</div>
      <div class="img_box flex-rowl">
        <img :src="require('@/assets/images/weibo_icon.png')" alt="" />
        <img :src="require('@/assets/images/wechat_icon.png')" alt="" />
      </div>
    </div> -->
    <!-- 底部装饰 -->
    <div class="footer_wrap">
      <div class="img">
        <img src="https://upload.vwingist.com/melscn/0image/2025/04/4992487787254717356.png" alt="" />
        <!-- <img :src="require('@/assets/images/footer_bg.png')" alt="" /> -->
      </div>
    </div>
    <div class="footer-copy flex-rowc">
      <p>- VESCOR ©‌ 2025 -</p>
    </div>
  </footer>
</template>
    
    <script>
export default {
  name: "Footer",
  data() {
    return {};
  },
};
</script>
    
<style scoped  lang="less">
.footer {
  background: #fff;
  // .footer-wrap{
  //   height: 236px;
  //   padding: 60px 13% 0;
  //   box-sizing: border-box;
  //   .txt {
  //     font-size: 14px;
  //     color: #333333;
  //     margin-bottom: 10px;
  //   }
  //   .img_box {
  //     img {
  //       width: 25px;
  //       margin-right: 20px;
  //     }
  //   }
  // }
  .footer_wrap {
    margin-bottom: -60px;
  }
  .footer-copy {
    height: 120px;
    font-size: 16px;
    color: #333333;
    // border-top: 1px solid #CCCCCC;
  }
}
</style>
    